import * as React from "react";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { useTryInStoreContext } from "../../context/context/context.js";
const useAABSelectedChoices = ({ isTryInStoreFlowEnabled } = {
  isTryInStoreFlowEnabled: false
}) => {
  const { isTryInStoreEnabled } = useFeatureToggles();
  const { getFormattedLabel, getLabel } = useIntl();
  const [showTryInStoreModal, setShowTryInStoreModal] = React.useState(false);
  const [tryInstoreStorage] = useTryInStoreContext();
  const createSelectedChoices = React.useCallback(
    (choices) => {
      const showTryInStoreItem = !!tryInstoreStorage?.length && isTryInStoreEnabled && isTryInStoreFlowEnabled;
      if (showTryInStoreItem) {
        const tryInStoreItem = {
          name: getFormattedLabel("appointments.component.selectedChoices.tryInStore", {
            labelData: {
              itemCount: tryInstoreStorage.length
            }
          }),
          action: getLabel("appointments.component.selectedChoices.change"),
          onClick: () => setShowTryInStoreModal(true)
        };
        return { tryInStoreItem, ...choices };
      }
      return choices;
    },
    [getFormattedLabel, getLabel, isTryInStoreEnabled, isTryInStoreFlowEnabled, tryInstoreStorage]
  );
  return React.useMemo(
    () => ({ createSelectedChoices, showTryInStoreModal, setShowTryInStoreModal }),
    [createSelectedChoices, showTryInStoreModal, setShowTryInStoreModal]
  );
};
export {
  useAABSelectedChoices
};
//# sourceMappingURL=use-aab-selected-choices.js.map
